import { ACTIVE_MENU_GROUP_LOCAL_STORAGE_KEY } from '@/constants/localStorageKeys.ts';
import { useLocalStorage } from '@/hooks/useLocalStorage.ts';

export const useNavItemsState = () => {
    return useLocalStorage < 'guidedReview' | 'comments' | 'element' > (ACTIVE_MENU_GROUP_LOCAL_STORAGE_KEY, 'guidedReview')
}
